// extracted by mini-css-extract-plugin
export default {"container":"UploadButton_container__lieaw","text":"UploadButton_text__IzrN1","icon":"UploadButton_icon__hFG1v","uploadName":"UploadButton_uploadName__xqnin"};